// extracted by mini-css-extract-plugin
export default {"editor":"styles_editor__vKgE-"};